import PrimaryButton from "canbook-style/ui/button/primary";
import { ButtonType } from "canbook-style/ui/button/models";
import ErrorPrompt from "canbook-style/ui/prompt/error";
import { OtpComponentCallback, useOtpState } from "../hooks";

export function OtpComponent({
  phone,
  email,
  id,
  callback,
}: {
  phone: string;
  email: string;
  id: string;
  callback: OtpComponentCallback;
}) {
  const {
    errors,
    apiError,
    isInProgress,
    otp,
    setApiError,
    handleOtpSubmit,
    isSubmittedOnce,
    resendOtp,
    timer,
    otpInputArray,
    otpInputRefs,
    handleChange,
    handleKeyDown,
  } = useOtpState(phone, email, id, callback);

  return (
    <div className="px-4 w-full mt-20 lg:mt-0 lg:w-1/2 xl:w-1/3 flex lg:items-center lg:justify-center">
      <div className="w-full sm:w-4/6 lg:w-3/4 mx-auto bg-surface flex flex-col gap-12">
        <h1 className="hidden lg:block d-header-1 text-font-primary">
          Sign up
        </h1>
        <div className="flex flex-col gap-10">
          <div className="w-full">
            <p className="header-2 text-font-primary">OTP Verification</p>
            <p className="body-2 text-font-secondary pt-1">
              {email
                ? "We've sent a 6 digit code to your email"
                : "We've sent a 6 digit code to your phone"}
            </p>
            <div className="flex pt-4 gap-3 items-center">
              <p className="text-primary subheader-1">
                {email ? email : phone}
              </p>
              <img
                src="/icons/edit.svg"
                alt="Edit"
                className="h-[18px] w-[18px] cursor-pointer"
                onClick={() => {
                  if (email) {
                    callback.onEditEmail();
                  } else {
                    callback.onEditPhone();
                  }
                }}
              />
            </div>
          </div>
          <form
            className="flex flex-col w-full gap-10"
            onSubmit={handleOtpSubmit}
          >
            <div className="flex flex-col w-full">
              <label className="body-2 text-font-disabled lg:text-font-secondary pl-3 pb-3">
                Enter code
              </label>
              <div className="flex justify-between w-full">
                {otpInputArray.map((val, index) => (
                  <input
                    aria-label="Code"
                    key={index}
                    ref={otpInputRefs[index]}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    className="border border-outline bg-container-low py-3 size-13 sm:size-14 lg:size-13 xl:size-[46px] 2xl:size-13 rounded-xl outline-none focus:border-primary caret-primary text-font-primary text-center subheader-1"
                    value={val}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                  />
                ))}
              </div>
              <div className="mt-1 error-message">
                {isSubmittedOnce &&
                  errors.find(
                    (error) => error.for == "otp" || error.for == "otp_length",
                  )?.message}
              </div>
            </div>
            <PrimaryButton
              type={ButtonType.submit}
              text="Verify"
              isExpanded={true}
              isDisabled={otp == "" || errors.length > 0}
              isInProgress={isInProgress}
            />
            <div className="flex justify-center m-button lg:!d-button gap-3">
              <p
                className={`${
                  timer > 0 ? "text-font-disabled" : "text-primary"
                } border-b border-primary cursor-pointer`}
                onClick={() => {
                  if (timer > 0) return;
                  resendOtp();
                }}
              >
                Resend OTP
              </p>{" "}
              {timer > 0 && (
                <span className="text-font-secondary">
                  00:{timer < 10 ? "0" + timer : timer}
                </span>
              )}
            </div>
          </form>
        </div>
        {apiError && (
          <ErrorPrompt error={apiError} onClose={() => setApiError("")} />
        )}
      </div>
    </div>
  );
}

export default OtpComponent;
